import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { usePartnerships } from "../../common/partnerships/store";
import { cls_newPartnership_grid_discipline_height, cls_newPartnership_grid_item_width, cls_newPartnership_grid_itemNarrow_width, cls_newPartnership_grid_itemWide_width } from "./view.css";
import { cls_colorCyan70, cls_colorMagenta60, cls_gap_form, cls_h5, cls_p4b, cls_p5r, cls_wrap } from "style/index.css";
import { cls_align_items_center, cls_align_items_flex_start, cls_align_items_stretch, cls_justify_content_center, cls_justify_content_space_between } from "framework/structural_components/hbox_vbox.css";
import { getAgeTypeRegular, getCompetitionClassTypeFromString, getCompetitionClassTypeRegular, getDisciplineTypeRegular, getSeriesTypeRegular } from "public_app/view/entity";
import { Button, Intent } from "framework/controls/button";
import { cls_form_area_box } from "style/form.css";
import { TextField } from "framework/controls/text_field";
import { getEntityField } from "framework/state/setfield";
import { useUIContext } from "common/uicontext/store";
import { AgeType, CompetitionClassType, CompetitorType, DisciplineType, SeriesType } from "public_app/events/entity";
import { Select, SelectItem } from "framework/controls/select";
import { Checkbox } from "framework/controls/checkbox";
import { getCollectionErrorsAsString } from "framework/validation/validatableentity";
import { LoginButton } from "common/login_dialog/login_dialog";
import { SearchSelect, SearchSelectItem } from "framework/controls/searchSelect";
import { Dialog, DialogContent, DialogTitle } from "framework/dialog/dialog";
import { NewAttendeeView } from "public_app/events/calendar/competition_registration/new_attendee/view";
import { useCompetitionRegistration } from "public_app/events/calendar/competition_registration/store";
import { useCountries } from "public_app/countries/store";
import { UrlPathOfAdminSection, UrlPathOfPublicSection } from "common/paths";
import { useLocation } from "wouter";
import { usePartnershipListAdmin } from "admin_app/partnerships/partnership_list_store";
import { useResponsivity } from "framework/responsivity/store";
export var NewPersonRegistrationDialog = function (props) {
    var _a, _b;
    var _c = usePartnerships(), state = _c[0], actions = _c[1];
    var _d = useCompetitionRegistration(), competitionRegistrationState = _d[0], competitionRegistrationActions = _d[1];
    var _e = useCountries(), loadCountries = _e[1].loadCountries;
    React.useEffect(function () {
        competitionRegistrationActions.setAvailableAttendees([]);
        loadCountries();
    }, []);
    React.useEffect(function () {
        var _a, _b, _c, _d;
        var personNumber = state.newPartnership.registrationDialogOpenForPersonNumber;
        if (personNumber !== null) {
            if ((personNumber === 1 && ((_a = state.newPartnership.selectedPerson1) === null || _a === void 0 ? void 0 : _a.key) === '*newFemale') || (personNumber === 2 && ((_b = state.newPartnership.selectedPerson2) === null || _b === void 0 ? void 0 : _b.key) === '*newFemale')) {
                competitionRegistrationActions.selectAttendee('*female');
            }
            if ((personNumber === 1 && ((_c = state.newPartnership.selectedPerson1) === null || _c === void 0 ? void 0 : _c.key) === '*newMale') || (personNumber === 2 && ((_d = state.newPartnership.selectedPerson2) === null || _d === void 0 ? void 0 : _d.key) === '*newMale')) {
                competitionRegistrationActions.selectAttendee('*male');
            }
        }
    }, [state.newPartnership.registrationDialogOpenForPersonNumber]);
    React.useEffect(function () {
        var _a, _b;
        var newIdt = (_b = (_a = competitionRegistrationState.newAttendee) === null || _a === void 0 ? void 0 : _a.entity) === null || _b === void 0 ? void 0 : _b.idt1;
        if (newIdt !== null && newIdt !== undefined) {
            var field = "idt".concat(state.newPartnership.registrationDialogOpenForPersonNumber);
            actions.setNewPartnershipEntityField(field, newIdt);
            actions.cancelNewPersonRegistration();
            actions.setNeedToReloadAvailablePeople(true);
        }
    }, [(_b = (_a = competitionRegistrationState.newAttendee) === null || _a === void 0 ? void 0 : _a.entity) === null || _b === void 0 ? void 0 : _b.idt1]);
    return React.createElement(Dialog, { open: state.newPartnership.registrationDialogOpenForPersonNumber !== null },
        React.createElement(DialogContent, null,
            React.createElement(DialogTitle, null, "Registrace nové osoby"),
            React.createElement(VBox, { className: [cls_gap_form, cls_align_items_flex_start] },
                React.createElement(NewAttendeeView, null),
                React.createElement(HBox, { className: [cls_gap_form, cls_justify_content_space_between] },
                    React.createElement(Button, { onClick: actions.cancelNewPersonRegistration, intent: Intent.NotAction }, 'Zrušit')))));
};
var getClassesFromRankingPoints = function (rp) {
    var _a, _b, _c, _d;
    var data = {
        couple: {
            stt: null,
            lat: null,
            sttSenior: null,
            latSenior: null,
        },
        duo: {
            stt: null,
            lat: null,
            sttSenior: null,
            latSenior: null,
        },
    };
    rp.forEach(function (r) {
        if (r.series === SeriesType.DanceSport && r.discipline === DisciplineType.Standard && r.rankingAge === AgeType.Adult && r.competitors === CompetitorType.Couple) {
            data.couple.stt = r.personalClass !== CompetitionClassType.Unknown ? r.personalClass : null;
        }
        if (r.series === SeriesType.DanceSport && r.discipline === DisciplineType.Latin && r.rankingAge === AgeType.Adult && r.competitors === CompetitorType.Couple) {
            data.couple.lat = r.personalClass !== CompetitionClassType.Unknown ? r.personalClass : null;
        }
        if (r.series === SeriesType.DanceSport && r.discipline === DisciplineType.Standard && r.rankingAge === AgeType.Senior && r.competitors === CompetitorType.Couple) {
            data.couple.sttSenior = r.personalClass !== CompetitionClassType.Unknown ? r.personalClass : null;
        }
        if (r.series === SeriesType.DanceSport && r.discipline === DisciplineType.Latin && r.rankingAge === AgeType.Senior && r.competitors === CompetitorType.Couple) {
            data.couple.latSenior = r.personalClass !== CompetitionClassType.Unknown ? r.personalClass : null;
        }
        if (r.series === SeriesType.DanceForAll && r.discipline === DisciplineType.Standard && r.rankingAge === AgeType.Adult && r.competitors === CompetitorType.Duo) {
            data.duo.stt = r.personalClass !== CompetitionClassType.Unknown ? r.personalClass : null;
        }
        if (r.series === SeriesType.DanceForAll && r.discipline === DisciplineType.Latin && r.rankingAge === AgeType.Adult && r.competitors === CompetitorType.Duo) {
            data.duo.lat = r.personalClass !== CompetitionClassType.Unknown ? r.personalClass : null;
        }
    });
    // Fix null to E for couple classes
    data.couple.stt = (_a = data.couple.stt) !== null && _a !== void 0 ? _a : CompetitionClassType.E;
    data.couple.lat = (_b = data.couple.lat) !== null && _b !== void 0 ? _b : CompetitionClassType.E;
    // Fix null Senior to Adult classes
    data.couple.sttSenior = (_c = data.couple.sttSenior) !== null && _c !== void 0 ? _c : data.couple.stt;
    data.couple.latSenior = (_d = data.couple.latSenior) !== null && _d !== void 0 ? _d : data.couple.lat;
    return data;
};
var allClassesTPV = [CompetitionClassType.Novice, CompetitionClassType.Bronze, CompetitionClassType.Silver, CompetitionClassType.Gold];
var allClassesDancesport = [CompetitionClassType.E, CompetitionClassType.D, CompetitionClassType.C, CompetitionClassType.B, CompetitionClassType.A, CompetitionClassType.M];
var tpvRestrictedClasses = [CompetitionClassType.D, CompetitionClassType.C, CompetitionClassType.B, CompetitionClassType.A, CompetitionClassType.M];
var getAvailableClassesFromPersonalClasses = function (c1, c2) {
    var _a, _b, _c, _d, _e, _f;
    var data = {
        couple: {
            stt: [CompetitionClassType.E],
            lat: [CompetitionClassType.E],
            sttSenior: [CompetitionClassType.E],
            latSenior: [CompetitionClassType.E],
        },
        duo: {
            stt: [CompetitionClassType.Novice, CompetitionClassType.Bronze, CompetitionClassType.Silver],
            lat: [CompetitionClassType.Novice, CompetitionClassType.Bronze, CompetitionClassType.Silver],
            sttSenior: [],
            latSenior: [],
        },
    };
    var classIndex1 = null;
    var classIndex2 = null;
    var idx1 = null;
    var idx2 = null;
    // Couple STT
    classIndex1 = allClassesDancesport.indexOf(c1.couple.stt);
    classIndex2 = allClassesDancesport.indexOf(c2.couple.stt);
    _a = classIndex1 <= classIndex2 ? [classIndex1, classIndex2] : [classIndex2, classIndex1], idx1 = _a[0], idx2 = _a[1];
    data.couple.stt = allClassesDancesport.filter(function (c, i) { return i >= idx1 && i <= idx2; });
    // Couple STT Senior
    classIndex1 = allClassesDancesport.indexOf(c1.couple.sttSenior);
    classIndex2 = allClassesDancesport.indexOf(c2.couple.sttSenior);
    _b = classIndex1 <= classIndex2 ? [classIndex1, classIndex2] : [classIndex2, classIndex1], idx1 = _b[0], idx2 = _b[1];
    data.couple.sttSenior = allClassesDancesport.filter(function (c, i) { return i >= idx1 && i <= idx2; });
    // Couple LAT
    classIndex1 = allClassesDancesport.indexOf(c1.couple.lat);
    classIndex2 = allClassesDancesport.indexOf(c2.couple.lat);
    _c = classIndex1 <= classIndex2 ? [classIndex1, classIndex2] : [classIndex2, classIndex1], idx1 = _c[0], idx2 = _c[1];
    data.couple.lat = allClassesDancesport.filter(function (c, i) { return i >= idx1 && i <= idx2; });
    // Couple LAT Senior
    classIndex1 = allClassesDancesport.indexOf(c1.couple.latSenior);
    classIndex2 = allClassesDancesport.indexOf(c2.couple.latSenior);
    _d = classIndex1 <= classIndex2 ? [classIndex1, classIndex2] : [classIndex2, classIndex1], idx1 = _d[0], idx2 = _d[1];
    data.couple.latSenior = allClassesDancesport.filter(function (c, i) { return i >= idx1 && i <= idx2; });
    // Duo STT
    if (c1.duo.stt === null || c2.duo.stt === null) {
        if (c1.duo.stt === CompetitionClassType.Gold || c2.duo.stt === CompetitionClassType.Gold) {
            data.duo.stt = [CompetitionClassType.Novice, CompetitionClassType.Bronze, CompetitionClassType.Silver, CompetitionClassType.Gold];
        }
        else {
            data.duo.stt = [CompetitionClassType.Novice, CompetitionClassType.Bronze, CompetitionClassType.Silver];
        }
    }
    else {
        classIndex1 = allClassesTPV.indexOf(c1.duo.stt);
        classIndex2 = allClassesTPV.indexOf(c2.duo.stt);
        _e = classIndex1 <= classIndex2 ? [classIndex1, classIndex2] : [classIndex2, classIndex1], idx1 = _e[0], idx2 = _e[1];
        data.duo.stt = allClassesTPV.filter(function (c, i) { return i >= idx1 && i <= idx2; });
    }
    // Duo LAT
    if (c1.duo.lat === null || c2.duo.lat === null) {
        if (c1.duo.lat === CompetitionClassType.Gold || c2.duo.lat === CompetitionClassType.Gold) {
            data.duo.lat = [CompetitionClassType.Novice, CompetitionClassType.Bronze, CompetitionClassType.Silver, CompetitionClassType.Gold];
        }
        else {
            data.duo.lat = [CompetitionClassType.Novice, CompetitionClassType.Bronze, CompetitionClassType.Silver];
        }
    }
    else {
        classIndex1 = allClassesTPV.indexOf(c1.duo.lat);
        classIndex2 = allClassesTPV.indexOf(c2.duo.lat);
        _f = classIndex1 <= classIndex2 ? [classIndex1, classIndex2] : [classIndex2, classIndex1], idx1 = _f[0], idx2 = _f[1];
        data.duo.lat = allClassesTPV.filter(function (c, i) { return i >= idx1 && i <= idx2; });
    }
    return data;
};
var baseCompetitorUrl = "".concat(UrlPathOfPublicSection, "/competitor/{competitorId}/partnerstvi");
var NewPartnershipContent = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var propsFromAdminClubId = (_a = props.fromAdminClubId) !== null && _a !== void 0 ? _a : null;
    var propsFromSecretaryAdmin = (_b = props.fromSecretaryAdmin) !== null && _b !== void 0 ? _b : false;
    var state_resp = useResponsivity()[0];
    var T_HFM = state_resp.thresholdHeaderForMobile;
    var _h = usePartnershipListAdmin(), state_partnershipListAdmin = _h[0], actions_partnershipListAdmin = _h[1];
    var _j = usePartnerships(), state0 = _j[0], actions = _j[1];
    var _k = useUIContext(), uiContextState = _k[0], uiContextActions = _k[1];
    var isSecretary = (_d = (_c = uiContextState.data) === null || _c === void 0 ? void 0 : _c.event_planning) === null || _d === void 0 ? void 0 : _d.isSecretary;
    var ownAttendees = ((_f = (_e = uiContextState.data) === null || _e === void 0 ? void 0 : _e.event_registration) === null || _f === void 0 ? void 0 : _f.attendees) || [];
    var ownSoloAttendees = ownAttendees.filter(function (a) { return a.type === CompetitorType.SoloDancer; });
    var ownAttendeeIdts = ownSoloAttendees.map(function (a) { return a.idt1; });
    React.useEffect(function () {
        uiContextActions.loadEventRegistrationUIContextWithDate(new Date());
        uiContextActions.loadEventPlanningUIContext();
        actions.resetForm();
    }, []);
    React.useEffect(function () {
        if (state0.newPartnership.needToReloadAvailablePeople === true) {
            uiContextActions.loadEventRegistrationUIContextWithDate(new Date());
            actions.setNeedToReloadAvailablePeople(false);
        }
    }, [state0.newPartnership.needToReloadAvailablePeople]);
    React.useEffect(function () {
        actions.resetPartnershipDataForNewAthletes();
    }, [state0.newPartnership.entity.idt1, state0.newPartnership.entity.idt2]);
    var state = usePartnerships()[0];
    React.useEffect(function () {
        actions.setAvailablePeople(ownSoloAttendees.map(function (a) {
            var person = {
                key: a.idt1.toString(),
                idt: a.idt1,
                name: "".concat(a.surname1, " ").concat(a.name1)
            };
            return person;
        }));
    }, [(_g = uiContextState.data) === null || _g === void 0 ? void 0 : _g.event_registration]);
    var filter1 = state.newPartnership.filter1;
    var filter2 = state.newPartnership.filter2;
    React.useEffect(function () {
        actions.filterPeople(1);
    }, [filter1, state.newPartnership.availablePeople]);
    React.useEffect(function () {
        actions.filterPeople(2);
    }, [filter2, state.newPartnership.availablePeople]);
    React.useEffect(function () {
        if (!state.newPartnership.partnershipSeriesSelectVisible) {
            actions.setNewPartnershipSeriesSelectVisible();
        }
    }, [state.newPartnership.partnershipSeriesSelectVisible]);
    var getter = function (field) {
        var value = getEntityField(state.newPartnership, field);
        return value === null || value === void 0 ? void 0 : value.toString();
    };
    var setter = function (field, value, validator, storeInvalidValue) {
        var numericalValue = parseInt(value);
        if (numericalValue.toString() === value) {
            return actions.setNewPartnershipEntityField(field, numericalValue, validator, storeInvalidValue);
        }
        else if (value === "") {
            return actions.setNewPartnershipEntityField(field, null, validator, storeInvalidValue);
        }
    };
    var getterCheckbox = function (field) {
        return getEntityField(state.newPartnership, field);
    };
    var setterCheckbox = function (field, value, validator, storeInvalidValue) {
        return actions.setNewPartnershipEntityField(field, value ? true : false, validator, storeInvalidValue);
    };
    var getterSelect = function (field) {
        var cls = getEntityField(state.newPartnership, field);
        if (cls) {
            return getCompetitionClassTypeRegular(cls);
        }
        return "";
    };
    var setterSelect = function (field, value, validator, storeInvalidValue) {
        return actions.setNewPartnershipEntityField(field, value ? getCompetitionClassTypeFromString(value) : null, validator, storeInvalidValue);
    };
    var getterSelectSeries = function () {
        if (state.newPartnership.partnershipSeries !== null) {
            return state.newPartnership.partnershipSeries.toString();
        }
        return "";
    };
    var setterSelectSeries = function (field, value, validator, storeInvalidValue) {
        if (value !== "") {
            return actions.setNewPartnershipSeries(parseInt(value));
        }
        return actions.setNewPartnershipSeries(null);
    };
    var athlete1 = state.athlete1.collection.length > 0 ? state.athlete1.collection[0] : null;
    var athlete2 = state.athlete2.collection.length > 0 ? state.athlete2.collection[0] : null;
    var bothPartnersFound = athlete1 != null && athlete2 != null;
    var canBeSeniorPartnership = false;
    var availableClassesSttAdult = [];
    var availableClassesLatAdult = [];
    var availableClassesSttSenior = [];
    var availableClassesLatSenior = [];
    var ageValues = [];
    var disciplines = [DisciplineType.Standard, DisciplineType.Latin];
    var classesChosenForSelectedDisciplines = true;
    var anyDisciplineSelected = false;
    var competitorType = null;
    var invalidSexes = false;
    var tpvDisabledForDCBAMClasses = false;
    var identicalItds = false;
    var availableSeries = [];
    var oneOrBothAthletesAreOwnedByUser = false;
    var userOwnsAthlete1 = false;
    var userOwnsAthlete2 = false;
    if (bothPartnersFound) {
        userOwnsAthlete1 = ownAttendeeIdts.includes(athlete1.idt) || isSecretary;
        userOwnsAthlete2 = ownAttendeeIdts.includes(athlete2.idt) || isSecretary;
        if (userOwnsAthlete1 || userOwnsAthlete2) {
            oneOrBothAthletesAreOwnedByUser = true;
        }
        if (athlete1.idt === athlete2.idt) {
            identicalItds = true;
        }
        var age1 = athlete1.age;
        var age2 = athlete2.age;
        var sex1 = athlete1.sex;
        var sex2 = athlete2.sex;
        if (sex1 === "F" && sex2 === "F") {
            competitorType = CompetitorType.Duo;
            availableSeries = [SeriesType.DanceForAll, SeriesType.Caribbean];
        }
        else if ((sex1 === "M" && sex2 === "F") || (sex1 === "F" && sex2 === "M")) {
            competitorType = CompetitorType.Couple;
            availableSeries = [SeriesType.DanceSport, SeriesType.Caribbean];
        }
        else {
            invalidSexes = true;
        }
        var seniorAgeTypeValues = [AgeType.Senior, AgeType.Senior_I, AgeType.Senior_Ia, AgeType.Senior_Ib, AgeType.Senior_II, AgeType.Senior_III, AgeType.Senior_IV, AgeType.Senior_V];
        canBeSeniorPartnership = state.newPartnership.partnershipSeries === SeriesType.DanceSport && seniorAgeTypeValues.includes(age1) && seniorAgeTypeValues.includes(age2) && (age1 !== AgeType.Senior_Ia || age2 !== AgeType.Senior_Ia);
        ageValues = canBeSeniorPartnership ? [AgeType.Adult, AgeType.Senior] : [AgeType.Adult];
        var classes1 = getClassesFromRankingPoints(athlete1.rankingPoints);
        var classes2 = getClassesFromRankingPoints(athlete2.rankingPoints);
        var availableClasses = getAvailableClassesFromPersonalClasses(classes1, classes2);
        if (competitorType === CompetitorType.Couple) {
            availableClassesSttAdult = availableClasses.couple.stt;
            availableClassesLatAdult = availableClasses.couple.lat;
            availableClassesSttSenior = availableClasses.couple.sttSenior;
            availableClassesLatSenior = availableClasses.couple.latSenior;
        }
        if (competitorType === CompetitorType.Duo) {
            availableClassesSttAdult = availableClasses.duo.stt;
            availableClassesLatAdult = availableClasses.duo.lat;
        }
        var entity = state.newPartnership.entity;
        if (entity.registerSttAdult === true && !entity.classSttAdult) {
            classesChosenForSelectedDisciplines = false;
        }
        if (entity.registerLatAdult === true && !entity.classLatAdult) {
            classesChosenForSelectedDisciplines = false;
        }
        if (entity.registerSttSenior === true && !entity.classSttSenior) {
            classesChosenForSelectedDisciplines = false;
        }
        if (entity.registerLatSenior === true && !entity.classLatSenior) {
            classesChosenForSelectedDisciplines = false;
        }
        if (entity.registerSttAdult || entity.registerLatAdult || entity.registerSttSenior || entity.registerLatSenior || entity.registerCarribean) {
            anyDisciplineSelected = true;
        }
        // if (competitorType === CompetitorType.Duo) {
        //     if (tpvRestrictedClasses.includes(classes1.couple.stt)) { tpvDisabledForDCBAMClasses = true; }
        //     if (tpvRestrictedClasses.includes(classes1.couple.lat)) { tpvDisabledForDCBAMClasses = true; }
        //     if (tpvRestrictedClasses.includes(classes1.couple.sttSenior)) { tpvDisabledForDCBAMClasses = true; }
        //     if (tpvRestrictedClasses.includes(classes1.couple.latSenior)) { tpvDisabledForDCBAMClasses = true; }
        //     if (tpvRestrictedClasses.includes(classes2.couple.stt)) { tpvDisabledForDCBAMClasses = true; }
        //     if (tpvRestrictedClasses.includes(classes2.couple.lat)) { tpvDisabledForDCBAMClasses = true; }
        //     if (tpvRestrictedClasses.includes(classes2.couple.sttSenior)) { tpvDisabledForDCBAMClasses = true; }
        //     if (tpvRestrictedClasses.includes(classes2.couple.latSenior)) { tpvDisabledForDCBAMClasses = true; }
        // }
    }
    var getDisciplineAndAgeString = function (discipline, age, canBeSenior) {
        var result = "".concat(getDisciplineTypeRegular(discipline));
        if (canBeSenior) {
            result += " (".concat(getAgeTypeRegular(age), ")");
        }
        return result;
    };
    var getCheckboxName = function (discipline, age) {
        if (discipline === DisciplineType.Caribbean) {
            return "registerCarribean";
        }
        if (discipline === DisciplineType.Standard && age === AgeType.Adult) {
            return "registerSttAdult";
        }
        if (discipline === DisciplineType.Latin && age === AgeType.Adult) {
            return "registerLatAdult";
        }
        if (discipline === DisciplineType.Standard && age === AgeType.Senior) {
            return "registerSttSenior";
        }
        if (discipline === DisciplineType.Latin && age === AgeType.Senior) {
            return "registerLatSenior";
        }
        return "";
    };
    var getSelectName = function (discipline, age) {
        if (discipline === DisciplineType.Standard && age === AgeType.Adult) {
            return "classSttAdult";
        }
        if (discipline === DisciplineType.Latin && age === AgeType.Adult) {
            return "classLatAdult";
        }
        if (discipline === DisciplineType.Standard && age === AgeType.Senior) {
            return "classSttSenior";
        }
        if (discipline === DisciplineType.Latin && age === AgeType.Senior) {
            return "classLatSenior";
        }
        return "";
    };
    var getAvailableClasses = function (discipline, age) {
        if (discipline === DisciplineType.Standard && age === AgeType.Adult) {
            return availableClassesSttAdult;
        }
        if (discipline === DisciplineType.Latin && age === AgeType.Adult) {
            return availableClassesLatAdult;
        }
        if (discipline === DisciplineType.Standard && age === AgeType.Senior) {
            return availableClassesSttSenior;
        }
        if (discipline === DisciplineType.Latin && age === AgeType.Senior) {
            return availableClassesLatSenior;
        }
        return [];
    };
    var registeredCompetitorId = state.newPartnership.entity.registeredCompetitorId;
    var partnershipRegistrationFinished = registeredCompetitorId !== null;
    var formControlsDisabled = state.newPartnershipSubmission.updating || partnershipRegistrationFinished;
    var globalError = getCollectionErrorsAsString(state.newPartnershipSubmission, "");
    var selectedPerson1 = state.newPartnership.selectedPerson1;
    var selectedPerson2 = state.newPartnership.selectedPerson2;
    var showIdtInput1 = selectedPerson1 !== null && selectedPerson1.key === "*customIdt";
    var showIdtInput2 = selectedPerson2 !== null && selectedPerson2.key === "*customIdt";
    var getSelItem = function (v) {
        return v == '' ? "Zvolte..." : state.newPartnership.availablePeople.find(function (x) { return x.key == v; }).name;
    };
    var _l = useLocation(), setLocation = _l[1];
    React.useEffect(function () {
        if (partnershipRegistrationFinished) {
            if (propsFromSecretaryAdmin === true) {
                if (state_partnershipListAdmin._initialized) {
                    actions_partnershipListAdmin.loadData();
                }
                setLocation("".concat(UrlPathOfAdminSection, "/clenove/partnerstvi"));
            }
            else if (propsFromAdminClubId !== null) {
                if (state_partnershipListAdmin._initialized) {
                    actions_partnershipListAdmin.loadData();
                }
                setLocation("".concat(UrlPathOfAdminSection, "/klub/").concat(propsFromAdminClubId, "/partnerstvi"));
            }
            else {
                setLocation("".concat(baseCompetitorUrl.replace('{competitorId}', registeredCompetitorId.toString())));
            }
        }
    }, [partnershipRegistrationFinished]);
    var classGridItemWidhtWide = cls_newPartnership_grid_itemWide_width;
    var classGridItemWidhtNormal = T_HFM ? cls_newPartnership_grid_itemWide_width : cls_newPartnership_grid_item_width;
    var classGridItemWidhtNarrow = T_HFM ? cls_newPartnership_grid_itemWide_width : cls_newPartnership_grid_itemNarrow_width;
    return React.createElement(VBox, { className: [cls_gap_form] },
        React.createElement(NewPersonRegistrationDialog, null),
        React.createElement(HBox, { className: [cls_h5] }, "Registrace nov\u00E9ho partnerstv\u00ED"),
        React.createElement(HBox, null,
            React.createElement(VBox, { className: [cls_form_area_box, cls_gap_form, cls_align_items_flex_start] }, partnershipRegistrationFinished === false && React.createElement(React.Fragment, null,
                React.createElement(HBox, { className: [cls_gap_form, cls_wrap] },
                    React.createElement(VBox, { className: [cls_gap_form] },
                        React.createElement(VBox, { className: [classGridItemWidhtNormal, cls_align_items_stretch] },
                            React.createElement(SearchSelect, { name: null, label: "Prvn\u00ED osoba", onFilter: actions.setFilter1, selectedValue: (selectedPerson1 === null || selectedPerson1 === void 0 ? void 0 : selectedPerson1.key) || '', onSelect: function (key) { return actions.selectPerson(1, key); }, keyToTextMapFunc: getSelItem }, state.newPartnership.filteredPeople1.map(function (p) { return React.createElement(SearchSelectItem, { key: p.key, keyValue: p.key.toString(), children: p.name }); }))),
                        showIdtInput1 && React.createElement(VBox, { className: [classGridItemWidhtNormal, cls_align_items_stretch] },
                            React.createElement(TextField, { label: "IDT prvn\u00ED osoby", name: "idt1", state: state.newPartnership, getter: getter, setter: setter, disabled: formControlsDisabled })),
                        athlete1 != null && React.createElement(VBox, { className: [cls_p4b, cls_colorCyan70, classGridItemWidhtNormal] },
                            React.createElement(HBox, null, athlete1.name))),
                    React.createElement(VBox, { className: [cls_gap_form] },
                        React.createElement(VBox, { className: [classGridItemWidhtNormal, cls_align_items_stretch] },
                            React.createElement(SearchSelect, { name: null, label: "Druh\u00E1 osoba", onFilter: actions.setFilter2, selectedValue: (selectedPerson2 === null || selectedPerson2 === void 0 ? void 0 : selectedPerson2.key) || '', onSelect: function (key) { return actions.selectPerson(2, key); }, keyToTextMapFunc: getSelItem }, state.newPartnership.filteredPeople2.map(function (p) { return React.createElement(SearchSelectItem, { key: p.key, keyValue: p.key.toString(), children: p.name }); }))),
                        showIdtInput2 && React.createElement(VBox, { className: [classGridItemWidhtNormal, cls_align_items_stretch] },
                            React.createElement(TextField, { label: "IDT druh\u00E9 osoby", name: "idt2", state: state.newPartnership, getter: getter, setter: setter, disabled: formControlsDisabled })),
                        athlete2 != null && React.createElement(VBox, { className: [cls_p4b, cls_colorCyan70] },
                            React.createElement(HBox, null, athlete2.name)))),
                bothPartnersFound && React.createElement(React.Fragment, null, oneOrBothAthletesAreOwnedByUser && competitorType !== null && !tpvDisabledForDCBAMClasses && !identicalItds ? React.createElement(VBox, { className: [cls_gap_form] },
                    React.createElement(HBox, { className: [cls_gap_form, cls_wrap, cls_align_items_center] },
                        React.createElement(VBox, { className: [cls_p4b, classGridItemWidhtNormal] }, competitorType === CompetitorType.Couple ? 'Registrace páru' : (competitorType === CompetitorType.Duo ? 'Registrace dua' : ''))),
                    React.createElement(HBox, { className: [cls_gap_form, cls_wrap, cls_align_items_center] },
                        React.createElement(VBox, { className: [classGridItemWidhtWide] }, state.newPartnership.partnershipSeriesSelectVisible && React.createElement(Select, { name: "partnershipSeries", label: "Seri\u00E1l", getter: getterSelectSeries, setter: setterSelectSeries, disabled: formControlsDisabled, placeholder: "Zvolte seri\u00E1l sout\u011B\u017E\u00ED..." }, availableSeries.map(function (s) { return React.createElement(SelectItem, { key: s.toString(), value: s.toString(), children: getSeriesTypeRegular(s) }); })))),
                    (state.newPartnership.partnershipSeries === SeriesType.DanceSport || state.newPartnership.partnershipSeries === SeriesType.DanceForAll) && React.createElement(React.Fragment, null, disciplines.map(function (discipline) {
                        return React.createElement(VBox, { key: discipline.toString(), className: [cls_gap_form] }, ageValues.map(function (age) {
                            var checkboxName = getCheckboxName(discipline, age);
                            var value = getterCheckbox(checkboxName);
                            var selectName = getSelectName(discipline, age);
                            var availableClasses = getAvailableClasses(discipline, age);
                            return React.createElement(VBox, { key: age.toString(), className: [cls_gap_form] },
                                React.createElement(HBox, { className: [cls_gap_form, cls_wrap, cls_align_items_center] },
                                    React.createElement(VBox, { className: [classGridItemWidhtWide, cls_newPartnership_grid_discipline_height, cls_justify_content_center] },
                                        React.createElement(Checkbox, { label: "Registrovat pro discipl\u00EDnu ".concat(getDisciplineAndAgeString(discipline, age, canBeSeniorPartnership)), name: checkboxName, getter: getterCheckbox, setter: setterCheckbox, disabled: formControlsDisabled })),
                                    value === true && React.createElement(VBox, { className: [classGridItemWidhtNarrow, cls_newPartnership_grid_discipline_height, cls_justify_content_center] },
                                        React.createElement(Select, { name: selectName, getter: getterSelect, setter: setterSelect, disabled: formControlsDisabled, placeholder: "Zvolte t\u0159\u00EDdu..." }, availableClasses.map(function (c) { return React.createElement(SelectItem, { key: c.toString(), value: getCompetitionClassTypeRegular(c), children: getCompetitionClassTypeRegular(c) }); })))));
                        }));
                    })),
                    state.newPartnership.partnershipSeries === SeriesType.Caribbean && React.createElement(React.Fragment, null,
                        React.createElement(VBox, { className: [cls_gap_form] }, ageValues.map(function (age) {
                            var checkboxName = getCheckboxName(DisciplineType.Caribbean, null);
                            return React.createElement(VBox, { key: age.toString(), className: [cls_gap_form] },
                                React.createElement(HBox, { className: [cls_gap_form, cls_wrap, cls_align_items_center] },
                                    React.createElement(VBox, { className: [cls_newPartnership_grid_itemWide_width, cls_newPartnership_grid_discipline_height, cls_justify_content_center] },
                                        React.createElement(Checkbox, { label: "Registrovat pro discipl\u00EDnu ".concat(getDisciplineTypeRegular(DisciplineType.Caribbean)), name: checkboxName, getter: getterCheckbox, setter: setterCheckbox, disabled: formControlsDisabled }))));
                        }))),
                    anyDisciplineSelected && classesChosenForSelectedDisciplines && React.createElement(React.Fragment, null, !partnershipRegistrationFinished && React.createElement(VBox, { className: classGridItemWidhtNormal },
                        React.createElement(Button, { intent: Intent.Primary, onClick: function () { return actions.submitPartnershipRegistration(); }, disabled: formControlsDisabled }, "Registrovat"))),
                    globalError !== null && React.createElement(HBox, { className: [cls_p5r, cls_colorMagenta60] }, globalError)) : React.createElement(VBox, { className: [cls_gap_form] },
                    !oneOrBothAthletesAreOwnedByUser && React.createElement(HBox, { className: [cls_p5r, cls_colorMagenta60] }, "Pro vytvo\u0159en\u00ED partnerstv\u00ED mus\u00EDte m\u00EDt opr\u00E1vn\u011Bn\u00ED alespo\u0148 k jedn\u00E9 osob\u011B."),
                    invalidSexes && React.createElement(HBox, { className: [cls_p5r, cls_colorMagenta60] }, "Registrovat je mo\u017En\u00E9 pouze mu\u017Ee (chlapce) a \u017Eenu (d\u00EDvku) jako p\u00E1r, nebo dv\u011B d\u00EDvky jako duo."),
                    tpvDisabledForDCBAMClasses && React.createElement(HBox, { className: [cls_p5r, cls_colorMagenta60] }, "Sout\u011B\u017E\u00ED se nemohou z\u00FA\u010Dastnit osoby, kter\u00E9 v minulosti byly dr\u017Eiteli t\u0159\u00EDdy D a vy\u0161\u0161\u00ED."),
                    identicalItds && React.createElement(HBox, { className: [cls_p5r, cls_colorMagenta60] }, "Pro vytvo\u0159en\u00ED partnerstv\u00ED mus\u00EDte zadat dv\u011B r\u016Fzn\u00E9 osoby.")))))));
};
export var NewPartnership = function (props) {
    var uiContextState = useUIContext()[0];
    var userIsLoggedIn = !!uiContextState.data.logged_user;
    return React.createElement(React.Fragment, null, userIsLoggedIn
        ? React.createElement(NewPartnershipContent, { fromAdminClubId: props.fromAdminClubId, fromSecretaryAdmin: props.fromSecretaryAdmin })
        : React.createElement(VBox, { className: cls_gap_form },
            React.createElement(HBox, null, "Pro zobrazen\u00ED obsahu se mus\u00EDte p\u0159ihl\u00E1sit do syst\u00E9mu."),
            React.createElement(HBox, null,
                React.createElement(LoginButton, { disableMobileVersionStyle: true }))));
};
